export type CardBounds = {
  id: string;
  left: number;
  right: number;
  top: number;
  bottom: number;
};

// Card edges, rather than centres, keep wide tables and tall charts easy to hit.
export function cardAtPoint(cards: CardBounds[], x: number, y: number) {
  if (!cards.length) return null;
  if (
    x < Math.min(...cards.map((c) => c.left)) - 24 ||
    x > Math.max(...cards.map((c) => c.right)) + 24 ||
    y < Math.min(...cards.map((c) => c.top)) - 24 ||
    y > Math.max(...cards.map((c) => c.bottom)) + 24
  )
    return null;
  let nearest: string | null = null;
  let distance = Infinity;
  for (const card of cards) {
    const dx = Math.max(card.left - x, 0, x - card.right);
    const dy = Math.max(card.top - y, 0, y - card.bottom);
    const next = dx * dx + dy * dy;
    if (next < distance) {
      nearest = card.id;
      distance = next;
    }
  }
  return nearest;
}

export function reorderCards(ids: string[], source: string, target: string) {
  const from = ids.indexOf(source),
    to = ids.indexOf(target);
  if (from < 0 || to < 0 || from === to) return [...ids];
  const next = [...ids];
  next.splice(from, 1);
  next.splice(to, 0, source);
  return next;
}
